import React from "react";
import { IonModal, IonContent, IonIcon } from "@ionic/react";
import { closeOutline } from "ionicons/icons";

import { AppStateDisplay } from "../../containers";
import CircleIconButton from "../circle-icon-button";

import "../../../../theme/modal.css";
import styled from "styled-components";

const Modal = styled(IonModal)`
  --min-width: 50vw;
  --min-height: 80vh;
  --border-radius: 20px;
  --border-color: rgba(0, 204, 204, 0.3);
`;
const ModalContent = styled(IonContent)`
  --background: radial-gradient(
    90.94% 90.94% at 50% 50%,
    rgba(44, 191, 201, 0.5) 0%,
    rgba(44, 191, 201, 0) 100%
  );
`;
const ModalHeader = styled.div`
  display: flex;
  margin-top: 16px;
  margin-right: 8px;
`;
const ModalTitle = styled.div`
  flex: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  align-content: center;
  font-family: Secular One;
  font-size: 1.5em;
  color: #4db6ac;
`;
const CloseIcon = styled(IonIcon)`
  color: #ffffff;
  font-weight: bold;
  font-size: 1.5em;
`;
const ActualContent = styled.div``;

const AppModal = (props) => {
  return (
    <Modal {...props}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle>
            {props.title ? props.title.toUpperCase() : props.title}
          </ModalTitle>
          <CircleIconButton
            style={{
              width: "40px",
              height: "40px",

              display: "flex",
              justifyContent: "center",
              alignContent: "center",
            }}
            onClick={props.handleClose}
          >
            <CloseIcon icon={closeOutline} />
          </CircleIconButton>
        </ModalHeader>
        <ActualContent>
          <AppStateDisplay>{props.children}</AppStateDisplay>
        </ActualContent>
      </ModalContent>
    </Modal>
  );
};

export default AppModal;
